import React from 'react';
import ReactGA from 'react-ga';
import { createBrowserHistory } from 'history';

import './colors.css';
import DashboardLayout from './layout/Dashboard/DashboardLayout';
import StandaloneLayout from './layout/Standalone/StandaloneLayout';
import WidgetLayout from './layout/Widget/WidgetLayout';
import PublicWidgetLayout from './layout/PublicWidget/PublicWidgetLayout';
import HERLayout from './layout/HER/HERLayout';
import {Redirect, Router, Switch, Route} from 'react-router-dom';
import { DASHBOARD_BASE_PATH, STANDALONE_PAGE_PATH, SSO_PATH, WIDGET_BASE_PATH, PUBLIC_WIDGET_BASE_PATH, HER_PATH } from './constants/paths';
import configureStore from './layout/appStore';
import { Provider } from 'react-redux';
import ErrorMain from './components/common/Error/ErrorMain';
import {setMixpanelSuperProperties} from './helpers/analyticsHelper';
import { createMuiTheme } from '@material-ui/core';
import { StylesProvider, ThemeProvider } from '@material-ui/styles';
import { LastLocationProvider } from 'react-router-last-location';
import { GA_TRACKING_ID, MOUSEFLOW_PROJECT_ID } from './constants/configs';
import SsoAuthenticationLayer from './components/samlSSO/SsoAuthenticationLayer';
import { addMouseflowTracker } from './helpers/mouseflowHelper';
import { Configuration } from './configs/Configuration';
import { addPickMySolar } from './helpers/pickMySolarHelper';
import ScrollHandler from './components/common/Scroller/ScrollHandler';

if(MOUSEFLOW_PROJECT_ID && MOUSEFLOW_PROJECT_ID !== ""){
  let configs = Configuration.getConfiguration();
  addMouseflowTracker(MOUSEFLOW_PROJECT_ID, configs.pilotId);
}
const browserHistory = createBrowserHistory();
ReactGA.initialize(GA_TRACKING_ID);
browserHistory.listen((location, action) => {
    ReactGA.pageview(location.pathname + location.search);
});
addPickMySolar();
function App() {
  setMixpanelSuperProperties();
  const theme = createMuiTheme({
    typography: {
      fontFamily: [
        'Montserrat',
        '"Helvetica Neue"',
        'Arial',
        'sans-serif',
      ].join(','),
    },
    props: {
      MuiButtonBase: {
        disableRipple: true, // No more ripple, on the whole application!
      },
    }
  });

  return (
    <StylesProvider injectFirst>
      <ThemeProvider theme={theme}>
        <div className="app">
          <Router history={browserHistory}>
            <ScrollHandler/>
            <LastLocationProvider>
              <Switch>
                <Redirect exact from="/" to={DASHBOARD_BASE_PATH} />
                <Route exact path={SSO_PATH}>
                  <Provider store={configureStore('Dashboard')}>
                    <SsoAuthenticationLayer />
                  </Provider>
                </Route>
                <Route path={DASHBOARD_BASE_PATH} >
                  <Provider store={configureStore('Dashboard')}>
                    <DashboardLayout />
                  </Provider>
                </Route>
                <Route path={WIDGET_BASE_PATH} >
                  <Provider store={configureStore('Widget')}>
                    <WidgetLayout />
                  </Provider>
                </Route>
                <Route path={PUBLIC_WIDGET_BASE_PATH} >
                  <Provider store={configureStore('PublicWidget')}>
                    <PublicWidgetLayout />
                  </Provider>
                </Route>
                <Route path={HER_PATH} >
                  <Provider store={configureStore('HER')}>
                    <HERLayout />
                  </Provider>
                </Route>
                <Route path={STANDALONE_PAGE_PATH} >
                  <Provider store={configureStore('Standalone')}>
                    <StandaloneLayout />
                  </Provider>
                </Route>
                <Route component={ErrorMain} />
              </Switch>
            </LastLocationProvider>
          </Router>
        </div>
      </ThemeProvider>
    </StylesProvider>
  );
}

export default App;
